






































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private ifShowSelect: any; // 是否显示已作答
  @Prop()
  private ifShowCorrer: any; // 是否显示正确与否
  @Prop()
  private data: any;
  @Watch("data", { immediate: true })
  private dataChange() {
    // setTimeout(() => {
    //   this.$forceUpdate();
    // }, 200);
    // 如果显示正确与否需要计算
  }
  @Prop()
  private questionIndex: any;
  @Prop()
  private ifShowCurrentSelect: any;
  private changeCurIdx(d: any) {
    this.$emit("change", d - 1);
  }
}
